export const tr = {
    'empty-custom-period': 'Gün sayısını belirtin',
    'empty-shows-limit': 'Gösterim sıklığını belirtin'
};
